import React from 'react'

export function NewIconArrow() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M7.49167 8.00426L10.075 5.42093C10.1917 5.30426 10.25 5.16121 10.25 4.99176C10.25 4.82232 10.1917 4.67648 10.075 4.55426C9.95833 4.43204 9.81389 4.36954 9.64167 4.36676C9.46944 4.36398 9.32222 4.42371 9.2 4.54593L6.18333 7.56259C6.12222 7.62371 6.07639 7.69176 6.04583 7.76676C6.01528 7.84176 6 7.92093 6 8.00426C6 8.08759 6.01528 8.16676 6.04583 8.24176C6.07639 8.31676 6.12222 8.38482 6.18333 8.44593L9.2 11.4626C9.32222 11.5848 9.46944 11.6445 9.64167 11.6418C9.81389 11.639 9.95833 11.5765 10.075 11.4543C10.1917 11.332 10.25 11.1862 10.25 11.0168C10.25 10.8473 10.1917 10.7043 10.075 10.5876L7.49167 8.00426Z'
        fill='currentColor'
      />
    </svg>
  )
}
